import { httpApi } from '@app/api/http.api';
import { LoginUserModel } from '@app/domain/LoginUserModel';

export interface ChangeNewPasswordData {
  confirmPassword: string;
  newPassword: string;
  password: string;
}

export interface GetByUserNameData {
  username: string;
}

export interface Pagination {
  current?: number;
  pageSize?: number;
  total?: number;
}

export interface UserTableData {
  data: UserTableRow[];
  pagination: Pagination;
}

export interface UserTableRow {
  Id: number;
  UserName: string;
  FirstName: string;
  LastName: string;
  Email: string;
  PhoneNumber: string;
  IsActive: boolean;
  IsFirstTimeLogin: boolean | null;
  CreatedDateTime: Date | null;
  ModifiedDateTime: Date | null;
  LastLoginDateTime: Date | null;
}

export interface UserTableRow {
  Id: number;
  UserName: string;
  FirstName: string;
  LastName: string;
  Email: string;
  PhoneNumber: string;
  IsActive: boolean;
  IsFirstTimeLogin: boolean | null;
  CreatedDateTime: Date | null;
  ModifiedDateTime: Date | null;
  LastLoginDateTime: Date | null;
}

export interface UserRegister {
  firstname: string;
  lastname: string;
  username: string;
  phonenumber: string;
  email: string;
  roles: number;
  companies: number[];
  pages: string[];
}

export const getUserTableData = (pagination: Pagination, searchString: string): Promise<UserTableData> =>
  httpApi
    .get<UserTableData>('/apim/v1/user', {
      params: { pagenumber: pagination.current, rowsOfpage: pagination.pageSize, searchstring: searchString },
    })
    .then(({ data }) => data);

export const getUserById = (id: number): Promise<LoginUserModel> =>
  httpApi.get<LoginUserModel>('/apim/v1/user/' + id).then(({ data }) => data);

export const updateUserById = (id: number, data: LoginUserModel): Promise<LoginUserModel> =>
  httpApi.put<LoginUserModel>('/apim/v1/user/' + id, { data }).then(({ data }) => data);

// eslint-disable-next-line
export const updateUserByIdAsync = (id: number, data: any): Promise<LoginUserModel> =>
  httpApi.put<LoginUserModel>('/apim/v1/user/' + id, { data }).then(({ data }) => data);

export const UserRegister = (data: UserRegister): Promise<UserRegister> =>
  httpApi.post<UserRegister>('/apim/v1/user/', { ...data }).then(({ data }) => data);

// eslint-disable-next-line
export const updateUserActiveInActiveById = (id: number, data: any): Promise<LoginUserModel> =>
  httpApi.put<LoginUserModel>('/apim/v1/user/' + id, { data }).then(({ data }) => data);

export const changeNewPassword = (id: number, newPasswordData: ChangeNewPasswordData): Promise<undefined> =>
  httpApi.put<undefined>('/apim/v1/user/changepassword/' + id, { ...newPasswordData }).then(({ data }) => data);
